<template>
  <div class="FieldCustom">
    <div v-html="field.html(application, this.$store)"></div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationFieldCustom',
  props: ['field'],
  computed: {
    application() {
      return this.$store.state.application || {}
    }
  }
}
</script>

<style scoped lang="scss">
.FieldCustom {
}
</style>
